import { render, staticRenderFns } from "./safePhone.vue?vue&type=template&id=187af5d4&scoped=true&"
import script from "./safePhone.vue?vue&type=script&lang=js&"
export * from "./safePhone.vue?vue&type=script&lang=js&"
import style0 from "@/styles/index.scss?vue&type=style&index=0&id=187af5d4&prod&lang=scss&scoped=true&"
import style1 from "./safePhone.vue?vue&type=style&index=1&id=187af5d4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187af5d4",
  null
  
)

export default component.exports